export class GetPostponedOrdersCount {
  static readonly type = '[PostponedOrders] Get Postponed Orders Count';
}
